module.exports = __webpack_public_path__ + "static/img/signHeader.6cf6af80.png";